module.exports = __webpack_public_path__ + "static/rfh-logo-fr-ee34fb0169c770970c34e8275145b51e.png";